import { FileText, MessagesSquare } from 'lucide-react';
import type { HomeResumeItem } from '@/hooks/useHomeDashboard';
import { cn } from '@/lib/utils';
import { formatRelativeTime } from '@/utils/date-utils';

export function ResumeItemRow({
  item,
  onOpen,
}: {
  item: HomeResumeItem;
  onOpen: (item: HomeResumeItem) => void;
}) {
  const Icon = item.kind === 'conversation' ? MessagesSquare : FileText;
  return (
    <li>
      <button
        type="button"
        onClick={() => onOpen(item)}
        className={cn(
          'group flex w-full items-center gap-3 rounded-xl py-2.5 text-left',
          'transition-colors hover:bg-slate-50 -mx-2 px-2',
        )}
      >
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-500 group-hover:bg-crimson-50 group-hover:text-crimson-700">
          <Icon className="h-3.5 w-3.5" strokeWidth={1.75} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-sm font-normal text-slate-700 group-hover:text-slate-900">
            {item.title}
          </span>
          <span className="mt-0.5 block truncate text-xs text-muted-foreground">
            {item.kind === 'conversation' ? 'Chat' : 'Draft'} · {item.matter_name}
          </span>
        </span>
        <span className="shrink-0 text-[11px] text-slate-400">
          {formatRelativeTime(item.updated_at)}
        </span>
      </button>
    </li>
  );
}
